import React from 'react';
import { styled } from '@mui/system';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

import CloudIcon from '@mui/icons-material/Cloud';
import AssessmentIcon from '@mui/icons-material/Assessment';
import StoreIcon from '@mui/icons-material/Store';
import GroupIcon from '@mui/icons-material/Group';

import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const StyledMenu = (props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    sx={{border: '1px solid #d3d4d5'}}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
);

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}));

export default function ServicesMenu({service, ...props}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        {Boolean(anchorEl) ? <ArrowDropUpIcon/> : <ArrowDropDownIcon/>}Our Services
      </Button>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <AnchorLink href='#cloud-computing' onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit' }}>
          <StyledMenuItem selected={service === 'cloud_computing' ? true : false}>
            <ListItemIcon>
              <CloudIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Work Faster" />
          </StyledMenuItem>
        </AnchorLink>
        <AnchorLink href='#intelligent-algorithms' onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit' }}>
          <StyledMenuItem selected={service === 'intelligent_algorithms' ? true : false}>
            <ListItemIcon>
              <AssessmentIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Work Smarter" />
          </StyledMenuItem>
        </AnchorLink>
        <AnchorLink href='#e-commerce' onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit' }}>
          <StyledMenuItem selected={service === 'e-commerce' ? true : false}>
            <ListItemIcon>
              <StoreIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Sell More" />
          </StyledMenuItem>
        </AnchorLink>
        <AnchorLink href='#customer-experience' onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit' }}>
          <StyledMenuItem selected={service === 'customer_experience' ? true : false}>
            <ListItemIcon>
              <GroupIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Delight Customers" />
          </StyledMenuItem>
        </AnchorLink>
      </StyledMenu>
    </div>
  );
}
